export default "__VITE_ASSET__BY1vk6xq__"